import React, { useEffect, useState } from "react";
import { Button, Link, Logo, Menu, SocialsLinks } from "components";
import { useIsClient } from "hooks";
import { WpWebAppSettings } from "codegen";
import "./GlobalFooter.scss";
import { graphql, useStaticQuery } from "gatsby";

interface FooterComponent {
  data: WpWebAppSettings;
}

const FooterComponent = ({ data }: FooterComponent): JSX.Element => {
  const {
    webAppSettings: {
      webAppSettings: { locations, locationsSecondary },
    },
    generalSettings: { title: appTitle },
  } = data;

  const [isHomePage, setHomePage] = useState(false);

  useEffect(() => {
    if (useIsClient) {
      location.pathname !== "/" ? setHomePage(false) : setHomePage(true);
    }
  }, []);

  return (
    <>
      <footer className="footer global-footer layout--large">
        <div className="footer__wrapper">
          <div>
            <Logo className="footer__logo" />
            <div className="footer__contact">
              {locations &&
                Object.keys(locations).length > 0 &&
                locations?.map((location, index) => {
                  return (
                    <div key={index} className="footer-location">
                      {location?.name && (
                        <span>
                          <strong>{location?.name}</strong>
                        </span>
                      )}

                      {location?.address && <address dangerouslySetInnerHTML={{ __html: location?.address }} />}

                      {location?.phone && (
                        <a href={`tel:${location?.phone.replace(/[^A-Z0-9]/gi, "")}`}>{location?.phone}</a>
                      )}
                      {location?.email && <a href={`mailto:${location?.email}`}>{location?.email}</a>}
                    </div>
                  );
                })}
              <SocialsLinks />
            </div>
          </div>
          <Menu menuLocation="FOOTER_NAVIGATION" className="footer__navigation" />
          <div className="footer__navigation__shop">
            <div className="footer__navigation__shop-inner">
              {/* TODO: Add this link to Footer options using ACF. */}
              <Link to="https://www.quantumdiesel.com.au/" className="button--primary" target="_blank">
                <Button variant="outline" colorScheme="secondary" rightIcon="ArrowLink">
                  Machine Shop
                </Button>
              </Link>
              <div className="locations-secondary">
                {locationsSecondary &&
                  Object.keys(locationsSecondary).length > 0 &&
                  locationsSecondary?.map((location, index) => {
                    return (
                      <div key={index} className="footer-location">
                        {location?.name && (
                          <span>
                            <strong>{location?.name}</strong>
                          </span>
                        )}

                        <div>
                          {location?.address && <address dangerouslySetInnerHTML={{ __html: location?.address }} />}

                          {location?.phone && (
                            <a href={`tel:${location?.phone.replace(/[^A-Z0-9]/gi, "")}`}>{location?.phone}</a>
                          )}
                          {location?.email && <a href={`mailto:${location?.email}`}>{location?.email}</a>}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="legal-footer layout--large">
        <div className="legal-footer__wrapper">
          <Menu menuLocation="LEGAL_NAVIGATION" className="typography--h6 legal__navigation" />
          <span className="copyright typography--h6">
            <span className="copyright-inner">
              &#169; {new Date().getFullYear()} {appTitle}
            </span>
          </span>
          <div className="legal-footer-distl">
            {isHomePage ? (
              <span className="distl typography--h6">
                Website by{" "}
                <a rel="noreferrer" target="_blank" href="https://distl.com.au/">
                  Distl
                </a>
              </span>
            ) : (
              <span className="distl typography--h6">Website by Distl</span>
            )}
          </div>
        </div>
      </footer>
    </>
  );
};

/**
 * The footer to be displayed throughout the site
 *
 * @returns Returns the Footer component to be used throughout the site
 *
 */
export const GlobalFooter = (): JSX.Element => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      wp {
        webAppSettings {
          webAppSettings {
            locations {
              name
              address
              email
              phone
            }
            locationsSecondary {
              name
              address
              email
              phone
            }
          }
        }
        generalSettings {
          title
        }
      }
    }
  `);
  return <FooterComponent data={data.wp} />;
};
